import { styled } from '@mui/material';

import ActionButton from '@components/ActionButton';

// TODO add colors to library
const linkHoverBg = '#EBF6F7';

export const sxStyles = {
  wrap: {
    display: 'flex',
    alignItems: 'center',
  },
  applyStepWrap: {
    display: 'flex',
    alignItems: 'center',

    '& > p:first-of-type': {
      marginRight: '0.75rem',
    },
  },
  applyBtn: {
    minWidth: '142px',
    minHeight: '48px',
    fontSize: '16px',
  },
  subHeaderSelectWrap: {
    width: '220px',
  },
};

export const StyledHeadSectionActions = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
  gap: '1rem',
  marginTop: '1.5rem',

  [theme.breakpoints.up('sm')]: {
    marginTop: '2.5rem',
  },

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
  },
}));

export const StyledApplyStepBtn = styled(ActionButton)(() => ({
  display: 'flex',
  minWidth: '100px',
  height: '48px',
  marginLeft: '0.5rem',

  '& > svg:first-of-type': {
    marginRight: '0.5rem',
  },

  '& > p:first-of-type': {
    fontSize: '16px',
  },
}));

export const StyledActionIcon = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  height: '32px',
  marginLeft: '0.5rem',
  cursor: 'pointer',

  '&:hover': {
    backgroundColor: theme.palette.grey['50'],
    borderRadius: '5px',
  },
}));

export const StyledFavoriteButton = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 600,
  padding: '0.75rem 1.5rem',
  color: theme.palette.primary.main,
  borderRadius: '4px',

  '& > svg:first-of-type': {
    marginRight: '0.75rem',
  },

  '&:hover': {
    backgroundColor: linkHoverBg,
    cursor: 'pointer',
  },
}));

export const StyledWebsiteLink = styled('a')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 600,
  padding: '0.75rem 1.5rem',
  color: theme.palette.primary.main,
  borderRadius: '4px',

  '& > svg:first-of-type': {
    marginRight: '0.75rem',
  },

  '&:hover': {
    backgroundColor: linkHoverBg,
    cursor: 'pointer',
  },
}));
